import { render, staticRenderFns } from "./SocialLinkEditor.vue?vue&type=template&id=3480ad97&scoped=true"
import script from "./SocialLinkEditor.vue?vue&type=script&lang=ts"
export * from "./SocialLinkEditor.vue?vue&type=script&lang=ts"
import style0 from "./SocialLinkEditor.vue?vue&type=style&index=0&id=3480ad97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3480ad97",
  null
  
)

export default component.exports